import Link from "next/link";
import { Stack, Heading, Text } from "@chakra-ui/react";
import { HEADING_VARIANTS } from "@/theme/components/heading";
import { FOOTER_CONSTANTS, IAAS_SERVICES } from "../footer.constants";

const FooterIaasServices = () => {
  return (
    <Stack spacing={6} color="white">
      <Heading variant={HEADING_VARIANTS.SUBTITLE2}>
        {FOOTER_CONSTANTS.IAAS_SERVICE}
      </Heading>
      <Stack>
        {IAAS_SERVICES.map((service) => (
          <Link href={service.path} key={service.path}>
            <Text _hover={{ textDecor: "underline" }}>{service.name}</Text>
          </Link>
        ))}
      </Stack>
    </Stack>
  );
};

export default FooterIaasServices;
